// Any billing write can change an invoice that another list or open sheet shows,
// so every one of them reloads rather than each caller guessing which.
const BILLING_SURFACE_KEYS = [
  "paymentTxn",
  "invoiceDetail",
  "invoiceActionContext",
  "invoices",
  "invoice_txns",
  "posPayments",
  "workOrderInvoices",
  "workOrder",
  "productSaleTxns",
  "posProductSaleTxns",
  "jobLineItems",
  "refundablePaymentMethods",
  "contactInvoices",
]

export const invalidateBillingSurfaces = (queryClient) =>
  Promise.all(
    BILLING_SURFACE_KEYS.map((key) => queryClient.invalidateQueries([key]))
  )
